import React from 'react';
import styles from './style.module.css';
import icon from 'assets/check-circle-light-green.svg';
import moment from 'moment';

const OrderCard = ({ data }) => {
  const getDescription = (code, long_description, trackingUrl) => {
    if (code === 'OutForDelivery') {
      return {
        __html: long_description.replace('{tracking}', '<a href="' + trackingUrl + '" target="_blank">Track</a>'),
      };
    } else {
      return { __html: long_description };
    }
  };

  return (
    <div className={`${styles.orderCard} drop-shadow`}>
      <div className={styles.orderCardHeader}>
        <h2>Order #{data.id}</h2>
        <p
          style={{
            backgroundColor: data.statuses[0].background_colour,
            color: data.statuses[0].text_colour,
          }}>
          {data.statuses[0].short_description}
        </p>
      </div>
      <p className={styles.orderCardSubheader}>Order placed on {moment(data.date).format('DD MMMM YYYY')}</p>
      <div className={styles.orderCardBodyTop}>
        {data.statuses.map(({ timestamp, short_description, code, long_description }) => (
          <div className={styles.orderCardBody} key={timestamp}>
            <div className={styles.orderCardIcon}>
              <img src={icon} alt="status icon" />
            </div>
            <div>
              <h3 className={styles.orderCardTextStatus}>{short_description}</h3>
              <p className={styles.orderCardTimeStamp}>{moment(timestamp).format('DD MMMM YYYY')}</p>
              <p
                className={styles.orderCardText}
                dangerouslySetInnerHTML={getDescription(code, long_description, data.trackingUrl)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderCard;
